import { z } from "zod";

import {
  ColorIconSchema,
  DetailsPopupInfoSchema,
  WorkTimeList,
} from "@shared/content-types/schemas/common.schema";
import { DynamicZoneSchema } from "@shared/content-types/schemas/dynamicZone.schema";
import { ArrayOfMediaSchema } from "@shared/content-types/schemas/media.schema";
import { TitleWithIconSchema } from "@shared/content-types/schemas/pageHero.schema";
import { MetaSchema } from "@shared/content-types/schemas/pagination.schema";
import { SeoSchema } from "@shared/content-types/schemas/seo.schema";

export const CafesRestaurantsPageSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  pageIcon: ColorIconSchema,
  titleWithIcon: TitleWithIconSchema,
});

export const CafesRestaurantsTypeSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  type: z.string().min(1),
  uid: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  cafes_restaurants_points: z.array(z.any()),
});

export const CafesRestaurantsBadgeTypeSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  type: z.string().min(1),
  uid: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  cafes_restaurants_points: z.array(z.any()),
});

export const CafesRestaurantsPointBaseSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  title: z.string().min(1),
  uid: z.string().min(1),
  description: z.string().min(1),
  phone: z
    .string()
    .regex(/^\d \(\d{3}\) \d{3} \d{2} \d{2}$/, "Invalid phone format")
    .optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  email: z.string().email().optional(),
  siteLink: z.string().optional(),
  averageCheck: z.string().optional(),
  cuisine: z.string().optional(),
  location: z.string(),
  workTimeList: z.array(WorkTimeList.dynamic).optional(),
  photos: ArrayOfMediaSchema,
  cafes_restaurants_types: z
    .array(CafesRestaurantsTypeSchema)
    .optional()
    .nullable(),
  cafes_restaurants_badge_types: z
    .array(CafesRestaurantsBadgeTypeSchema)
    .min(0),
  coordinates: z.string(),
  detailInfo: z.array(DetailsPopupInfoSchema),
  content: DynamicZoneSchema.optional().nullable(),
  seo: SeoSchema.optional().nullable(),
});

export const CafesRestaurantsPointSchema =
  CafesRestaurantsPointBaseSchema.extend({
    other_cafes_restaurants: z
      .array(CafesRestaurantsPointBaseSchema)
      .optional(),
  });

export const CafesRestaurantsPageDtoSchema = z.object({
  data: CafesRestaurantsPageSchema,
});

export const CafesRestaurantsPointDtoSchema = z.object({
  data: z.array(CafesRestaurantsPointSchema).min(0),
  meta: MetaSchema,
});

export const CafesRestaurantsTypesDtoSchema = z.object({
  data: z.array(CafesRestaurantsTypeSchema).min(0),
  meta: MetaSchema,
});

export const CafesRestaurantsBadgeTypesDtoSchema = z.object({
  data: z.array(CafesRestaurantsBadgeTypeSchema).min(0),
  meta: MetaSchema,
});
